module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_link_image_plan-499c58f07b138c98a51d8ede3a53628f.jpg";